// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__25hmUz4MXVQ_Gm0kHD9VUp","wide":"style_wide__35QdiQreIrzOnwrvilr7o_","buttons":"style_buttons__3ym_JG0r9A3IGRHAmILUkR"};